var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-item button-widget",style:({
    ..._vm.style,
    ...(_vm.widget.object.imageAsButton ? _vm.style : _vm.buttonStyle),
  }),attrs:{"id":_vm.widget.object.wid,"title":_vm.widget.object.captionText},on:{"click":_vm.openButtonModal}},[(_vm.widget.object.imageAsButton && _vm.widget.object.imageUrl)?_c('img',{style:(_vm.imageStyle),attrs:{"src":_vm.widget.object.imageUrl}}):(!_vm.widget.object.imageAsButton)?_c('span',{staticClass:"button-text"},[_vm._v(" "+_vm._s(_vm.widget.object.text)+" ")]):_vm._e()])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }